var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#2B4896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.6785 523.153L552.27 -38.0068L556.795 66.0793L-15.6785 523.153Z",
    fill: "#DD7500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-16.4844 522.836L607.483 24.71L601.005 128.693L-16.4844 522.836Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.116 43.6973L166.007 158.35H152.224L159.116 43.6973Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.363 79.0563L167.242 160.528L150.99 156.173L180.363 79.0563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/MH.04a9699d94c6908aeb2e7f991b9be521.svg";
export { ForwardRef as ReactComponent };